
    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CardladderData"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CardladderData"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cl_id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"cl_market_value"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"cl_average_price"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"cl_num_sales"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"cl_low_price"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"cl_high_price"},"arguments":[],"directives":[]}]}}],"loc":{"start":0,"end":137}};
    doc.loc.source = {"body":"fragment CardladderData on CardladderData {\n  cl_id\n  cl_market_value\n  cl_average_price\n  cl_num_sales\n  cl_low_price\n  cl_high_price\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

      module.exports = doc;
    
